/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypes.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Saturday, September 15, 2018 - 10:18 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      09/15/2018  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const APP_LOAD = 'APP_LOAD';
export const SIDEBARSHOW = 'SIDEBARSHOW';
export const SIDEBARUNFOLDABLE = 'SIDEBARUNFOLDABLE';
export const ASIDESHOW = 'ASIDESHOW';
export const REDIRECT = 'REDIRECT';

export const USER_LOGGED_IN = 'USER_LOGGED_IN';
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT';
export const UPDATE_FIELD_AUTH = 'UPDATE_FIELD_AUTH';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const LOGIN_PAGE_UNLOADED = 'LOGIN_PAGE_UNLOADED';

export const HOME_PAGE_LOADED = 'HOME_PAGE_LOADED';
export const HOME_PAGE_UNLOADED = 'HOME_PAGE_UNLOADED';
export const HOME_LOAD_NAVIGATION = 'HOME_LOAD_NAVIGATION';

export const ASYNC_START = 'ASYNC_START';
export const ASYNC_END = 'ASYNC_END';

/*  COMMON */

export const REDIRECT_ADDCANCEL = 'REDIRECT_ADDCANCEL';
export const REDIRECT_EDIT = 'REDIRECT_EDIT';
export const COMMON_UPDATE_FILTER = 'COMMON_UPDATE_FILTER';
export const COMPONENT_UNLOAD = 'COMPONENT_UNLOAD';

/* SHOPPING */

export const SITE_CREATECART = 'SITE_CREATECART';
export const SITE_ADDITEM = 'SITE_ADDITEM';
export const SITE_UPDATEITEM = 'SITE_UPDATEITEM';
export const SITE_REMOVEITEM = 'SITE_REMOVEITEM';
export const SITE_GETCHECKOUT = 'SITE_GETCHECKOUT';

/* CMS SELECT */

export const OPEN_CMSSELECT = 'OPEN_CMSSELECT';
export const CLOSE_CMSSELECT = 'CLOSE_CMSSELECT';
export const LOAD_CMSSELECT = 'LOAD_CMSSELECT';
export const FOLDER_CONTENTS_LOADED = 'FOLDER_CONTENTS_LOADED';

/*  REGISTRATION */

export const REGISTER_LOADED = 'REGISTER_LOADED';
export const REGISTER_UNLOADED = 'REGISTER_UNLOADED';
export const REGISTER_UPDATE_FIELD = 'REGISTER_UPDATE_FIELD';
export const REGISTER_CHECK_USERNAME = 'REGISTER_CHECK_USERNAME';
export const REGISTER_CHECK_EMAIL = 'REGISTER_CHECK_EMAIL';
export const REGISTER_CHECK_PASSWORD = 'REGISTER_CHECKPASSWORD';
export const REGISTER_ERROR = 'REGISTER_ERROR';
export const REGISTER_SUBMIT = 'REGISTER_SUBMIT';

/*  RECOVER LOGIN INFORMATION */

export const FORGOTLOGIN_LOADED = 'FORGOTLOGIN_LOADED';
export const FORGOTLOGIN_UNLOADED = 'FORGOTLOGIN_UNLOADED';
export const FORGOTLOGIN_FORM_LOADED = 'FORGOTLOGIN_FORM_LOADED';
export const FORGOTLOGIN_FORM_UNLOADED = 'FORGOTLOGIN_FORM_UNLOADED';
export const FORGOTLOGIN_FORM_USERNAME_SUBMIT = 'FORGOTLOGIN_FORM_USERNAME_SUBMIT';
export const FORGOTLOGIN_FORM_PASSWORD_SUBMIT = 'FORGOTLOGIN_FORM_PASSWORD_SUBMIT';

/*  PRIMARY API URL */

//export const API_ROOT = 'http://104.186.28.123:5000';
//export const API_ROOT = 'https://api.miinews.com';
export const API_ROOT = 'https://www.miiapp.us/';
export const API_ROOT_LAMBDA = 'https://w4f2z4c35e.execute-api.us-east-1.amazonaws.com/dev';
//export const API_ROOT = 'http://127.0.0.1:5000';
export const S3_ROOT = 'https://www.miiapp.org/'